import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProjectSettingsService {
  private apiBase = '';

  constructor() {
    this.apiBase = environment.apiManagmet;
  }

  public generateEndpoint(apiEndpoint: string, ...args: string[]): string {
    const apiEndpointFormatted = apiEndpoint.replace(/{(\d+)}/g, (match, index) => args[index] || '');
    const base = this.apiBase;
    return `${base}/${apiEndpointFormatted}`;
  }
}
